// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Zcgka","container":"styles_container__9vcbv","innerContainer":"styles_innerContainer__SMVye"};